"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Type = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _interfaces = require("../../../interfaces");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Type = function Type(_ref) {
  var _ref2;
  var type = _ref.type,
    internal = _ref.internal,
    betweenAccounts = _ref.betweenAccounts,
    fiat = _ref.fiat,
    invoiceId = _ref.invoiceId,
    overPaid = _ref.overPaid,
    fullyPaid = _ref.fullyPaid,
    paidAmount = _ref.paidAmount;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransaction'),
    t = _useTranslation.t;
  if (fiat && type === _interfaces.TransactionType.WITHDRAWAL && !betweenAccounts) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('type.fiat.' + type));
  }
  if ((_ref2 = invoiceId && type === _interfaces.TransactionType.DEPOSIT) !== null && _ref2 !== void 0 ? _ref2 : paidAmount && fullyPaid) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('type.invoice.' + type));
  if (!fiat && paidAmount && !fullyPaid) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('type.invoice.' + (overPaid ? 'overpaid' : 'underpaid')));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, betweenAccounts ? t('type.accountTransfer') : t("type.".concat(internal ? 'internal.' : '').concat(type)));
};
exports.Type = Type;